<template>
  <div class="d-flex justify-start">
    <div class="d-flex flex-column" style="width: 350px;">
      <v-alert
        dense
        outlined
        type="error"
        v-if="msgPacienteNoEncontrado"
        transition="scale-transition"
      >
        Paciente no encontrado,
        <strong>regístrate</strong>
      </v-alert>
      <span class="font-weight-light title mb-4 text-center">Ingresar</span>

      <v-form v-model="formValidated" ref="form">
        <v-text-field
          v-model="rut"
          label="Rut"
          :rules="[
                () => !!rut || 'Campo requerido',
                () => isValidRut() || 'Rut inválido' 
              ]"
          validate-on-blur
          outlined
          prepend-inner-icon="person"
        ></v-text-field>
        <v-text-field
          v-model="password"
          label="Contraseña"
          :rules="[ () => !!password || 'Campo requerido' ]"
          outlined
          type="password"
          prepend-inner-icon="lock"
        ></v-text-field>
        <div class="d-flex mt-4">
          <v-btn
            class="flex"
            @click="logear"
            color="primary"
          >Iniciar sesión</v-btn>
        </div>
      </v-form>
      <v-btn to="/recordar-contraseña" text class="mt-4 caption">Recuperar contraseña</v-btn>
      <v-btn to="/registrarse" text class="mt-4">Registrarse</v-btn>
    </div>
  </div>
</template>

<script>
export default {
  name: "LoginForm",
  data: () => ({
    rut: "",
    password: "",
    formValidated: false,
    msgPacienteNoEncontrado: false
  }),
  methods: {
    isValidRut() {
      if (!this.rut) {
        this.validRut = false;
        return this.validRut;
      }
      if (this.rut.length < 7) {
        this.validRut = false;
        return this.validRut;
      }
      let cleanRut = this.$rutjs.clean(this.rut);
      this.validRut = this.$rutjs.validate(cleanRut);
      if (this.validRut) {
        this.rut = this.$rutjs.format(cleanRut);
      }
      return this.validRut;
    },
    logear: async function($event) {
      if (!this.$refs.form.validate()) {
        this.formValidated = true;
        return;
      }
      try {
        let rut = this.rut.replace(/\./g, "");
        let password = this.password;
        await this.$store.dispatch("login", { rut, password });
        if (this.$store.getters.getFromUrl) {
          this.$router.push(this.$store.getters.getFromUrl);
          this.$store.dispatch("saveFromUrl", "");
        } else {
          this.$router.push("/mis-citas");
        }
        this.$emit("login");
      } catch (err) {
        this.msgPacienteNoEncontrado = true;
        console.log(err);
      }
    },
    recuperarContraseña: async function() {}
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
